import React from 'react';
import { observer } from 'mobx-react';
import { HiveThemeProvider } from '@routific/hive';
import { V5ThemeProvider } from '@routific/hive/v5';
import { useResolvedV5Theme } from '../../../hooks/useV5Theme';

interface Props {
  children: React.ReactNode;
}

/**
 * The routes-page order details panel renders inside an antd Drawer portal,
 * outside the app-level V5ThemeProvider. Re-provide the resolved theme here
 * (including the session dark-mode override). Footer schedule/unschedule
 * actions still use v4 ActionButtons, so the v4 Hive theme is nested too.
 */
const OrderDetailsThemeBoundary: React.FC<Props> = observer(({ children }) => {
  const { colorMode, density } = useResolvedV5Theme();

  return (
    <V5ThemeProvider colorMode={colorMode} density={density}>
      <HiveThemeProvider>{children}</HiveThemeProvider>
    </V5ThemeProvider>
  );
});

export default OrderDetailsThemeBoundary;
